/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_User_Removed_From_Group_SuccessInputs */

const en_team_manager_user_removed_from_group_success = /** @type {(inputs: Team_Manager_User_Removed_From_Group_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`User removed from group successfully`)
};

const fr_team_manager_user_removed_from_group_success = /** @type {(inputs: Team_Manager_User_Removed_From_Group_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utilisateur retiré du groupe avec succès`)
};

const de_team_manager_user_removed_from_group_success = /** @type {(inputs: Team_Manager_User_Removed_From_Group_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benutzer erfolgreich aus der Gruppe entfernt`)
};

const it_team_manager_user_removed_from_group_success = /** @type {(inputs: Team_Manager_User_Removed_From_Group_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utente rimosso dal gruppo con successo`)
};

const ru_team_manager_user_removed_from_group_success = /** @type {(inputs: Team_Manager_User_Removed_From_Group_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пользователь успешно удален из группы.`)
};

const es_team_manager_user_removed_from_group_success = /** @type {(inputs: Team_Manager_User_Removed_From_Group_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usuario eliminado del grupo exitosamente`)
};

const zh_cn2_team_manager_user_removed_from_group_success = /** @type {(inputs: Team_Manager_User_Removed_From_Group_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`用户已成功从群组中移除`)
};

const ja_team_manager_user_removed_from_group_success = /** @type {(inputs: Team_Manager_User_Removed_From_Group_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ユーザーはグループから正常に削除されました`)
};

const hi_team_manager_user_removed_from_group_success = /** @type {(inputs: Team_Manager_User_Removed_From_Group_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उपयोगकर्ता को समूह से सफलतापूर्वक हटा दिया गया`)
};

const pt_pt2_team_manager_user_removed_from_group_success = /** @type {(inputs: Team_Manager_User_Removed_From_Group_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usuário removido do grupo com sucesso`)
};

/**
* | output |
* | --- |
* | "User removed from group successfully" |
*
* @param {Team_Manager_User_Removed_From_Group_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_user_removed_from_group_success = /** @type {((inputs?: Team_Manager_User_Removed_From_Group_SuccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_User_Removed_From_Group_SuccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_manager_user_removed_from_group_success(inputs)
	if (locale === "de") return de_team_manager_user_removed_from_group_success(inputs)
	if (locale === "it") return it_team_manager_user_removed_from_group_success(inputs)
	if (locale === "ru") return ru_team_manager_user_removed_from_group_success(inputs)
	if (locale === "es") return es_team_manager_user_removed_from_group_success(inputs)
	if (locale === "zh-CN") return zh_cn2_team_manager_user_removed_from_group_success(inputs)
	if (locale === "ja") return ja_team_manager_user_removed_from_group_success(inputs)
	if (locale === "hi") return hi_team_manager_user_removed_from_group_success(inputs)
	if (locale === "pt-PT") return pt_pt2_team_manager_user_removed_from_group_success(inputs)
	return en_team_manager_user_removed_from_group_success(inputs)
});